import { useMemo } from 'react';

import { Column } from '@tanstack/react-table';

import { Person } from '@/../../backend/src/matter/person/person.entity';
import { PersonType } from '@/../../backend/src/types/types';
import { capitalizeFirstLetter } from '@/helpers/filterNames';
import { FilterMultiSelect } from '@/new/components/filter/filter-multi-select';
import { FilterPopoverContent } from '@/new/components/filter-popover-content';

export function EntityFilters({
  typeColumn,
  clearAllFilters,
}: {
  typeColumn?: Column<Person, unknown>;
  clearAllFilters: () => void;
}) {
  const types = useMemo(() => Object.values(PersonType), []);

  const typeFilterValue = typeColumn?.getFilterValue();
  const selectedTypes = Array.isArray(typeFilterValue) ? typeFilterValue : [];

  return (
    <FilterPopoverContent clearAllFilters={clearAllFilters}>
      <div>
        {typeColumn && (
          <>
            <p className="mb-3 text-gray-600">Entity Type</p>
            <FilterMultiSelect
              values={selectedTypes}
              options={types}
              column={typeColumn}
              placeholder="Select entity types..."
              formatLabel={capitalizeFirstLetter}
            />
          </>
        )}
      </div>
    </FilterPopoverContent>
  );
}
